import {Component, OnDestroy, OnInit} from '@angular/core';
import {takeWhile} from 'rxjs/operators';
import {UserService} from '../../services/user/user.service';
import {CarrierService} from '../../services/carrier/carrier.service';
import {BehaviorSubject, timer} from 'rxjs';
import {LoadingService} from '../../services/loading/loading.service';
import {AlertService} from '../../services/alert/alert.service';
import {BidCycleService} from '../hhg-rate-duns/bidcycle.service';
import {RoutingStateService} from '../../services/routing-state.service';
import { Router } from '@angular/router';
import {UploadComponent} from "../upload/upload.component";
import {FrtRatesDownloadComponent} from "../frt-rates-download/frt-rates-download.component";
import {FrtRateEditComponent} from "../frt-rate-edit/frt-rate-edit.component";
import {FrtRateGlobalUpdateComponent} from "../frt-rate-global-update/frt-rate-global-update.component";
import {CommonModule, NgFor, NgIf} from "@angular/common";
import {TabsModule} from "ngx-bootstrap/tabs";
import {FrtTemplateDownloadComponent} from "../frt-template-download/frt-template-download.component";

@Component({
    selector: 'app-frt-rate-view',
    templateUrl: './frt-rate-view.component.html',
    styleUrls: ['./frt-rate-view.component.css'],
    imports: [UploadComponent, FrtRatesDownloadComponent,
        FrtRateEditComponent, FrtRateGlobalUpdateComponent, CommonModule, TabsModule, FrtTemplateDownloadComponent, NgIf]
})
export class FrtRateViewComponent implements OnInit, OnDestroy {
  public activeTab: string;
  showViewRate: Boolean = true;
  observer$ = new BehaviorSubject(true);
  isRateFilingClosed$ =  new BehaviorSubject(false);
  rateBidCycleName: any;
  closingDate: number = null;

  constructor(private carrierService: CarrierService,
              private loader: LoadingService,
              private alertService: AlertService,
              private bidCycleService: BidCycleService,
              private userService: UserService,
              private routing: RoutingStateService,
              private router: Router) {
                if (this.router.getCurrentNavigation().extras.state) {
                  this.rateBidCycleName = this.router.getCurrentNavigation().extras.state.bicCycleObj[0].bidcycleName;
                }
  }

  ngOnInit() {
    timer(1000, 1000)
      .pipe(takeWhile(() => !this.isRateFilingClosed$.value))
      .subscribe(val => {
        this.userService.isRateFilingClosed()
          .pipe(takeWhile(() => this.observer$.value))
          .subscribe(res => {
            this.isRateFilingClosed$.next(res);
            if (res) {
              this.alertService.warn('Rate Filing Window has been closed!');
            }
          });
      });
  }

  /**
   * @description listens to changes in tab selection and lazy loades the component according to the tab heading.
   * @param $event: tab directive data including heading.
   */
  onSelectTab($event) {
    this.showViewRate = false;
    if ($event.heading === 'FRT View Rates') {
      this.activeTab = 'zero';
      this.routing.addCrumbsFromTabs('frtView');
    } else if ($event.heading === 'FRT Template Download') {
      this.activeTab = 'one';
      this.routing.addCrumbsFromTabs('frtTemplate');
    } else if ($event.heading === 'FRT Upload Rate File') {
      this.activeTab = 'two';
      this.routing.addCrumbsFromTabs('frtUpload');
    } else if ($event.heading === 'FRT Edit Rates') {
      this.activeTab = 'three';
      this.routing.addCrumbsFromTabs('frtEdit');
    } else if ($event.heading === 'FRT Global Update') {
      this.activeTab = 'four';
      this.routing.addCrumbsFromTabs('frtGlobal');
    }
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }

}
